<div class="p-4 bg-white flex flex-col rounded-lg font-app-bold w-[97%] mx-auto mb-3">
  <div class="flex items-end">
    <div class="items-center justify-between w-full">
      <span class="font-app-regular text-dark text-sm md:text-base col-start-1">
        {{ untilTextKey | translate }}
      </span>
    </div>
    <span class="text-sm md:text-base font-app-regular text-darkest w-1/2 text-end">
      {{ validityDate !== null ? (validityDate | date: "dd/MM/yyyy") : ("contractDetails.noPayment" | translate) }}
    </span>
  </div>
  <div
    class="flex mt-3"
    *ngIf="monthlyPremiumTTC !== 0">
    <div class="items-center justify-between w-full">
      <span class="font-app-regular text-dark text-sm md:text-base col-start-1">
        {{ amountTextKey | translate }}
      </span>
    </div>
    <span class="text-sm md:text-base font-app-regular text-darkest">
      {{ monthlyPremiumTTC | currency: "EUR" : "symbol" : "" : "fr" }}
    </span>
  </div>
  <div
    class="mt-3 flex justify-between"
    *ngIf="promotionCode !== null">
    <div class="items-center justify-between w-full">
      <span class="font-app-regular text-dark text-sm md:text-base col-start-1">
        {{ promoTextKey | translate }}
      </span>
    </div>
    <span class="text-sm md:text-base w-1/3 text-end font-app-regular text-darkest">
      {{ promotionCode }}
    </span>
  </div>
  <div
    class="mt-3 flex justify-between"
    *ngIf="effectiveStartDate">
    <div class="items-center justify-between w-full">
      <span class="font-app-regular text-dark text-sm md:text-base col-start-1">
        {{ "contractCard.effectiveDate" | translate }}
      </span>
    </div>
    <span class="text-sm md:text-base w-1/3 text-end font-app-regular text-darkest">
      {{ effectiveStartDate | date: "dd/MM/yyyy" }}
    </span>
  </div>
  <div
    class="mt-3 flex justify-between"
    *ngIf="terminationDate">
    <div class="items-center justify-between w-full">
      <span class="font-app-regular text-dark text-sm md:text-base col-start-1">
        {{ "contractCard.terminationDate" | translate }}
      </span>
    </div>
    <span class="text-sm md:text-base w-1/3 text-end font-app-regular text-darkest">
      {{ terminationDate | date: "dd/MM/yyyy" }}
    </span>
  </div>
</div>

